var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 2,
    fill: "#E8EAED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 14,
    height: 2,
    fill: "#9AA0A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 10,
    height: 2,
    fill: "#9AA0A6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 2,
    height: 2,
    fill: "#9AA0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/default-card.371a65443d395f135102c81595782f27.svg";
export { ForwardRef as ReactComponent };